import { useMemo } from "react"
import {
  Block,
  LabelMedium,
  SideNavItemTitle,
  SideNavLeadingIcon,
} from "@mezo-org/mezo-clay"

import { SidebarNavigationItemProps } from "#/shared/constants"
import { useCurrentRoute } from "#/shared/hooks"

export default function SidebarNavigationItem({
  navigationTitle,
  route,
  Icon,
  posthogDataAttribute,
}: Omit<SidebarNavigationItemProps, "pageTitle">) {
  const isCurrentRoute = useCurrentRoute(route)

  const color = useMemo(
    () => (isCurrentRoute ? "black" : "gray800"),
    [isCurrentRoute],
  )

  return (
    <SideNavItemTitle data-attr={posthogDataAttribute}>
      <SideNavLeadingIcon>
        <Icon size={20} color={color} />
      </SideNavLeadingIcon>
      <Block
        width="100%"
        padding="2px 24px 2px 0"
        alignItems="center"
        justifyContent="space-between"
      >
        <LabelMedium color={color}>{navigationTitle}</LabelMedium>
      </Block>
    </SideNavItemTitle>
  )
}
